/**
 * Concern IDs excluded from user-facing lists (charts, scores grid, history columns, etc.).
 * Does not remove data from API responses — filters display only.
 */
export const EXCLUDED_CONCERNS = new Set<string>([
  'eye_wrinkles',
  'dark_circle',
]);

/**
 * Concerns shown in multi-concern UI (excludes overall skin_health + EXCLUDED_CONCERNS).
 */
export function isConcernListed(concern: string): boolean {
  if (concern === 'skin_health') return false;
  return !EXCLUDED_CONCERNS.has(concern);
}
